const taskFormEndpoints = {
  FORMS: 'loopay-form-management/forms',
  SUBMITTED_FORMS: 'loopay-task-form-management/task-forms',
  SUBMITTED_FORM_DETAILS: (id: string) =>
    `loopay-task-form-management/task-form/${id}/details`,
} as const;

export default taskFormEndpoints;
